export const grayBorderStyle = { border: '1px solid #dfe5eb' };

export enum Row {
  AnyColor = 'anyColor',
  BlackWhite = 'blackWhite',
  CustomColor = 'customColor',
}
